export var FRONT_ATTACHMENT = '__NATIVE_FRONT_ATTACHMENT__';
export var FILE = '__NATIVE_FILE__';
export var URL = '__NATIVE_URL__';
export var TEXT = '__NATIVE_TEXT__';
export var HTML = '__NATIVE_HTML__';